module.exports = __webpack_public_path__ + "img/wch.125f751d.svg";